import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-6">
      <div className="mi-surface w-full max-w-lg p-10 text-center">
        <XCircle className="w-14 h-14 text-[#A0AAB5] mx-auto mb-6" />
        <h1 className="mi-headline text-4xl mb-3">Trial not started</h1>
        <p className="text-[#A0AAB5] mb-8">You cancelled before completing checkout. Come back any time — the first 7 days are still free.</p>
        <Link to="/" data-testid="cancel-return-home" className="mi-btn-red">
          <ArrowLeft className="w-4 h-4" /> Back to Motor iNKS
        </Link>
      </div>
    </div>
  );
}
